import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=77ed2054&scoped=true"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"
import style0 from "./Campus.vue?vue&type=style&index=0&id=77ed2054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed2054",
  null
  
)

export default component.exports